import React from 'react';
import PropTypes from 'prop-types';
import Question from './Question';
import { CONSTANTS } from '../Helpers/Configuration';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { makeStyles } from '@ellucian/react-design-system/core';
import ConditionalLogicCheck, { isConditionallyRequiredContext } from './ConditionalLogicCheck';
const useStyles = makeStyles(theme => ({
    root: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridGap: spacing40,
    },
    groupRoot: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridColumnGap: spacing40,
        gridTemplateColumns: 'repeat(6, 1fr)',
    },
    questionCount1: {
        gridColumn: 'span 3',
    },
    questionCount2: {
        gridColumn: 'span 3',
    },
    questionCount3: {
        gridColumn: 'span 2',
    },
    questionExpanded: {
        gridColumn: 'span 6'
    },
    [theme.breakpoints.down('sm')]: {
        groupRoot: {
            gridTemplateColumns: '1fr',
            gridRowGap: spacing40,
        },
        questionCount1: {
            gridColumn: 'span 1',
        },
        questionCount2: {
            gridColumn: 'span 1',
        },
        questionCount3: {
            gridColumn: 'span 1',
        },
        questionExpanded: {
            gridColumn: 'span 1'
        },
    },
}));

const QuestionGroups = props => {
    const {
        groups = [],
        prefix,
        repeatingSection = false,
        sectionId,
        pageId
    } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {groups.map((group, groupIndex) => {
                const questionClass = classes[`questionCount${group.questions.length.toString()}`];
                return (
                    <div key={groupIndex} className={classes.groupRoot}>
                        {group.questions.map((q, questionIdx) => {
                            return (
                                <ConditionalLogicCheck
                                    key={questionIdx}
                                    conditions={q.conditions}
                                    prefix={prefix}
                                    content={q}
                                    contentType={CONSTANTS.appTemplateControlTypes.question}
                                    repeatingSection={repeatingSection}
                                    sectionId={sectionId}
                                >
                                    <div className={q.columnWidth === CONSTANTS.columnWidthOptions.extended ? classes.questionExpanded : questionClass}>
                                        <isConditionallyRequiredContext.Consumer>
                                            {isConditionallyRequired =>
                                                <Question
                                                    prefix={prefix}
                                                    question={q}
                                                    isConditionallyRequired={isConditionallyRequired}
                                                    pageId={pageId}
                                                />
                                            }
                                        </isConditionallyRequiredContext.Consumer>
                                    </div>
                                </ConditionalLogicCheck>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};
QuestionGroups.propTypes = {
    groups: PropTypes.array,
    prefix: PropTypes.string,
    repeatingSection: PropTypes.bool,
    sectionId: PropTypes.string,
    pageId: PropTypes.string.isRequired
};
export default QuestionGroups;
